@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.FlexContainer {
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  height: fit-content;

  &.row {
    flex-flow: row wrap;
  }

  &.column {
    flex-flow: column wrap;
  }
}
